exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ui.table[data-v-95a05578] {\n    word-break: break-all;\n&.mt[data-v-95a05578] {\n        margin-top: 8px;\n}\ntd[data-v-95a05578]:first-child {\n        width: 70px;\n}\n}\n", ""]);

// exports
